module.exports = __webpack_public_path__ + "static/img/14001011.c8d159d1.png";